<template>
	<div class="d-flex justify-center amelipro-tooltip">
		<VTooltip
			v-model="show"
			:color="tooltipBgStyle"
			:content-class="'tooltip-' + tooltipId + '-js'"
			eager
			max-width="300px"
			right
			@keyup.esc="show = false"
		>
			<template #activator="{ on, attrs }">
				<slot
					:activator="{ on, attrs }"
					name="tooltipActivator"
				>
					<AmeliproIconBtn
						:aria-describedby="tooltipId"
						btn-label="informations utilisateur"
						class="tooltip-btn"
						icon="aide"
						icon-bg-color="ap-white"
						icon-color="ap-parme darken-1"
						icon-hover-bg-color="ap-parme darken-1"
						icon-hover-color="ap-white"
						large
						v-bind="attrs"
						v-on="on"
					/>
				</slot>
			</template>

			<slot name="default">
				<span
					class="amelipro-tooltip__text"
					:style="tooltipTextStyle"
				>
					{{ tooltipText }}
				</span>
			</slot>
		</VTooltip>
	</div>
</template>

<script setup lang="ts">
	import { computed, onMounted, ref } from 'vue';
	import AmeliproIconBtn from '../AmeliproIconBtn/AmeliproIconBtn.vue';
	import { IndexedObject } from '../../types';
	import { VTooltip } from 'vuetify/lib';
	import { convertToHex } from '../../functions/convertToHex';

	const props = defineProps({
		tooltipBg: {
			type: String,
			default: 'ap-white',
		},
		tooltipId: {
			type: String,
			default: 'tooltip',
		},
		tooltipText: {
			type: String,
			default: 'Test',
		},
		tooltipTextColor: {
			type: String,
			default: 'ap-grey darken-1',
		},
	});

	const show = ref(false);

	const tooltipTextStyle = computed<IndexedObject>(() => ({ color: convertToHex(props.tooltipTextColor) }));
	const tooltipBgStyle = computed<string>(() => convertToHex(props.tooltipBg));

	const injectTooltipAttributes = (): void => {
		const tooltip = document.querySelector(`.tooltip-${props.tooltipId}-js`);
		tooltip?.setAttribute('id', props.tooltipId);
		tooltip?.setAttribute('role', 'tooltip');
	};

	onMounted(() => injectTooltipAttributes());
</script>

<style lang="scss" scoped>
.v-tooltip__content {
	border: 1px solid $ap-parme-darken1 !important;
}

.v-btn {
	&.tooltip-btn {
		width: 1.85em !important;
		height: 1.85em !important;
	}
}
</style>
